import { navigateTo } from "./navigator";
import isMobile from "is-mobile";

const windowNavigator = window.navigator;
const standalone = "standalone";
let initialized = false;

let isSupported = false;

function init() {
	if (initialized) {
		return;
	}

	isSupported = isMobileDevice();

	// If the navigator contains the property standalone it means on IDevices that it
	// is on the homescreen
	if (isIOsStandAlone()) {
		homeScreenAnchorFix(document);
	}

	// if the browser is mobile and supported for mobile
	if (isSupported) {
		// make the bar black so the word editor can be closed, else the top bar of the
		// editor window will be under the apple wifi, time, battery and not be visible.
		document.querySelector(`meta[name="apple-mobile-web-app-status-bar-style"]`)
			?.setAttribute("content", "black");
	}

	initialized = true;
}

// Standalone is true when it is on the ipad opened from the homescreen (fullscreen view)
function isIOsStandAlone() {
	if (standalone in windowNavigator
		&& windowNavigator[standalone]
	) {
		return true;
	} else {
		return false;
	}
}

function isAndroidStandAlone() {
	if (window.matchMedia("(display-mode: standalone)").matches) {
		return true;
	} else {
		return false;
	}
}

// This code is being used when the workspace is added to the homescreen on the ipad/iphone/ipod
// It changes the way anchors work so you won't leave the homepage "application" but redirect the current page to the page
// you were suppose to be going
// Normal behaviour is that he opens a anchor in the browser because homepage type apps are meant to be single page
// source: http://stackoverflow.com/questions/2898740/iphone-safari-web-app-opens-links-in-new-window
// Discussion: https://gist.github.com/kylebarrow/1042026
function homeScreenAnchorFix(document: Document) {
	let curnode: any = null;
	const location = document.location;
	const anchorCheck = /^(a|html)$/i;
	document.addEventListener("click", function (e) {
		curnode = e.target;

		//Itterate from the clicked element upwards in the DOM tree until a anchor node is found
		while (!anchorCheck.test(curnode.nodeName)) {
			curnode = curnode.parentNode;
		}
		if ("href" in curnode && (curnode.href.indexOf("http") >= 0 || curnode.href.indexOf(location.host) >= 0) && curnode.target === false) {
			e.preventDefault();
			navigateTo(curnode.href);
		}
	}, false);
}

function isMobileDevice() {
	return isMobile();
}

function isIpad() {
	return windowNavigator.userAgent.match(/iPad/i) !== null;
}

function isIos() {
	return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function hasStackingContextIssues(): boolean {
	// Some browsers have issues with the stacking context (at the time of writting this
	// is only IOs and IPadOs). Sometimes we can work around it using the "fix-ios-z-index-glitch"
	// lessjs mixin, but in other cases we cannot (e.g. the work around creates a new stacking context).
	// In those cases we might want the product to behave different, hence this helper function to determine
	// those cases.
	// For an example of were we could not use the work around: #35311
	return isIos();
}

function isAndroid() {
	return navigator.userAgent.toLowerCase().indexOf("android") !== -1;
}

function isSafari(): boolean {
	return navigator.userAgent.toLowerCase().indexOf("safari") !== -1;
}

// all tablets that do not count as desktop(flipable screen etc) have in there user agent mobile
// so this is used to detect tablets and lower (mobile)
function isTabletOrMobile() {
	return (navigator.userAgent.toLowerCase().indexOf("mobile") >= 0);
}

function isWindows() {
	// User agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/101.0.4951.67 Safari/537.36
	return (navigator.userAgent.indexOf("(Windows ") !== -1 );
}

export {
	init,
	isMobileDevice,
	isTabletOrMobile,
	isIOsStandAlone,
	isAndroidStandAlone,
	isIpad,
	isIos,
	isAndroid,
	isSafari,
	isWindows
};
